<template>
	<div>
		<div class="page-tabs-box">
			<div class="fl" style="position: relative; z-index: 100;">
				<el-dropdown @command="handleCommand">
					<el-button type="primary">
						展开所有白名单<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(item, index) in allTabs" :key="index" :command="item.name">
							{{ item.label }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<el-tabs v-model="activeName">
				<el-tab-pane v-for="tab in allTabs" :key="tab.name" :label="tab.label" :name="tab.name">
					<component :is="tab.component" :is-active="activeName === tab.name"></component>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
	import Tab1 from './components/tab1';
	import Tab2 from './components/tab2';
	import Tab3 from './components/tab3';
	import Tab4 from './components/tab4';
	import Tab5 from './components/tab5';
	import Tab6 from './components/tab6';
	import Tab7 from './components/tab7';
	import Tab8 from './components/tab8';
	import Tab9 from './components/tab9';
	import Tab10 from './components/tab10';
	import Tab11 from './components/tab11';
	import Tab12 from './components/tab12';
	import Tab13 from './components/tab13';
	import Tab14 from './components/tab14';
	import Tab15 from './components/tab15';
	import Tab16 from './components/tab16';
	import Tab17 from './components/tab17';
	// 所有标签页配置数组
	const allTabsConfig = [{
			label: "查看待审核演出",
			name: "1",
			component: 'Tab1',
			isWhiteList: false
		},
		{
			label: "演出订单列表和导出",
			name: "2",
			component: 'Tab2',
			isWhiteList: false
		},
		{
			label: "查看演出收藏数",
			name: "3",
			component: 'Tab3',
			isWhiteList: false
		},
		{
			label: "导出乐迷手机号",
			name: "4",
			component: 'Tab4',
			isWhiteList: false
		},
		{
			label: "导出乐迷实名信息",
			name: "5",
			component: 'Tab5',
			isWhiteList: false
		},
		{
			label: "技术参数设置",
			name: "6",
			component: 'Tab6',
			isWhiteList: false
		},
		{
			label: "专业版门票核销",
			name: "7",
			component: 'Tab7',
			isWhiteList: false
		},
		{
			label: "专业版周边自取",
			name: "8",
			component: 'Tab8',
			isWhiteList: false
		},
		{
			label: "经营平台导座位号",
			name: "9",
			component: 'Tab9',
			isWhiteList: false
		},
		{
			label: "查看App演出排序分",
			name: "10",
			component: 'Tab10',
			isWhiteList: false
		},
		{
			label: "免费发送营销短信",
			name: "11",
			component: 'Tab11',
			isWhiteList: false
		},
		{
			label: "演出订单详情页",
			name: "12",
			component: 'Tab12',
			isWhiteList: true
		},
		{
			label: "周边订单手机号",
			name: "13",
			component: 'Tab13',
			isWhiteList: true
		},
		{
			label: "B类用户联系人",
			name: "14",
			component: 'Tab14',
			isWhiteList: true
		},
		{
			label: "演出全量票导出",
			name: "15",
			component: 'Tab15',
			isWhiteList: true
		},
		{
			label: "短信包模式",
			name: "16",
			component: 'Tab16',
			isWhiteList: true
		},
		{
			label: "订单强制取消",
			name: "17",
			component: 'Tab17',
			isWhiteList: true
		}
	];
	export default {
		components: {
			Tab1,
			Tab2,
			Tab3,
			Tab4,
			Tab5,
			Tab6,
			Tab7,
			Tab8,
			Tab9,
			Tab10,
			Tab11,
			Tab12,
			Tab13,
			Tab14,
			Tab15,
			Tab16,
			Tab17
		},
		data() {
			return {
				activeName: "1",
				allTabs: allTabsConfig
			}
		},

		methods: {
			handleCommand(commandName) {

				this.activeName = commandName;
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .from-tip {
		color: $--color-font-gray;
	}
</style>